"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _format = _interopRequireDefault(require("date-fns/format"));
var _getDay = _interopRequireDefault(require("date-fns/getDay"));
var _isWithinInterval = _interopRequireDefault(require("date-fns/isWithinInterval"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _DEFAULT_BRANCH_TIMING = _interopRequireDefault(require("@lumirental/lumi-web-sdk/dist/constants/date/DEFAULT_BRANCH_TIMING"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function getSpecialTimingProps(specialDays, selectedDay) {
  // picking only the date here because UTC time may be differ
  var formattedSelectedDay = new Date((0, _format["default"])(selectedDay, 'MMMM dd, YYY'));
  var selectedSpecialTiming = specialDays === null || specialDays === void 0 ? void 0 : specialDays.find(function (specialDay) {
    return (0, _isWithinInterval["default"])(formattedSelectedDay, {
      start: specialDay === null || specialDay === void 0 ? void 0 : specialDay.startDate,
      end: specialDay === null || specialDay === void 0 ? void 0 : specialDay.endDate
    });
  });
  var selectedWeekDay = (0, _getDay["default"])(formattedSelectedDay);
  var onDays = (0, _get2["default"])(selectedSpecialTiming, 'onDays', {});
  var offDays = (0, _get2["default"])(selectedSpecialTiming, 'offDays', []);
  var specialTimingDay = (0, _get2["default"])(onDays, "".concat(selectedWeekDay), _DEFAULT_BRANCH_TIMING["default"]);
  return {
    isTodaySpecialDay: !!selectedSpecialTiming,
    specialTimingWeek: (0, _get2["default"])(selectedSpecialTiming, 'timings', []),
    specialOffDays: offDays,
    specialOnDays: onDays,
    specialTimingDay: specialTimingDay
  };
}
var _default = exports["default"] = getSpecialTimingProps;